import React from 'react';
import { Card, Form, Select, Input, Row, Col, Space, Button } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { FormInstance } from 'antd/es/form';

const { Option } = Select;

interface CoworkersInformationProps {
  form: FormInstance;
}

const CoworkersInformation: React.FC<CoworkersInformationProps> = ({ form }) => {
  const yesNoOptions = ['Yes', 'No'];
  const discriminationBasisOptions = [
    'Age', 'Color', 'Mental/Physical Handicap', 'National Origin',
    'Race', 'Religion', 'Reprisal', 'Sex'
  ];

  return (
    <Card title="Coworkers' Information" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="Were other employees treated the same way as you?"
            name={['coworkers_info', 'other_employees_treated_same']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Did your coworkers have the same or very similar job?"
            name={['coworkers_info', 'coworkers_same_job']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Did your coworkers work for the same supervisor?"
            name={['coworkers_info', 'coworkers_same_supervisor']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Card type="inner" title="Coworkers' Information">
        <Row gutter={16}>
          <Col span={10}>
            <div style={{ fontWeight: 'bold', marginBottom: 8 }}>Names:</div>
          </Col>
          <Col span={10}>
            <div style={{ fontWeight: 'bold', marginBottom: 8 }}>Bases:</div>
          </Col>
          <Col span={4}>
            {/* Empty column for button alignment */}
          </Col>
        </Row>
        <Form.List name={['coworkers_info', 'coworkers']}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Row key={key} gutter={16} style={{ marginBottom: 8 }}>
                  <Col span={10}>
                    <Form.Item
                      {...restField}
                      name={[name, 'name']}
                      label={`${name + 1}:`}
                    >
                      <Input placeholder="Enter name" />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item
                      {...restField}
                      name={[name, 'basis']}
                      label=" "
                    >
                      <Select placeholder="Select basis">
                        {discriminationBasisOptions.map(option => (
                          <Option key={option} value={option}>{option}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item label=" ">
                      <Button
                        type="text"
                        danger
                        icon={<MinusCircleOutlined />}
                        onClick={() => remove(name)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              ))}
              {fields.length < 3 && (
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    Add Coworker
                  </Button>
                </Form.Item>
              )}
            </>
          )}
        </Form.List>
      </Card>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Were your coworkers the same basis as you?"
            name={['coworkers_info', 'coworkers_same_basis']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Different Supervisor's name:"
            name={['coworkers_info', 'different_supervisor_name']}
          >
            <Input placeholder="Enter name" />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default CoworkersInformation;

